import * as Constants from './constants'

export const khachhangListRequest = function khachhangListRequest(formData) {
  return {
    type: Constants.KHACHHANG_LIST_REQUESTING,
    payload: formData
  }
}

export const khachhangListSuccess = function khachhangListSuccess(data) {
  return {
    type: Constants.KHACHHANG_LIST_SUCCESS,
    data
  }
}

export const khachhangListError = function khachhangListError(error) {
  return {
    type: Constants.KHACHHANG_LIST_ERROR,
    error
  }
}
export const khachhangExportXlsRequest = function khachhangExportXlsRequest(formData, callback) {
  return {
    type: Constants.KHACHHANG_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const khachhangExportXlsSuccess = function khachhangExportXlsSuccess(data) {
  return {
    type: Constants.KHACHHANG_EXPORT_XLS_SUCCESS,
    data
  }
}

export const khachhangExportXlsError = function khachhangExportXlsError(error) {
  return {
    type: Constants.KHACHHANG_EXPORT_XLS_ERROR,
    error
  }
}
export const khachhangDetailRequest = function khachhangDetailRequest(formData) {
  return {
    type: Constants.KHACHHANG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const khachhangDetailSuccess = function khachhangDetailSuccess(data) {
  return {
    type: Constants.KHACHHANG_DETAIL_SUCCESS,
    data
  }
}

export const khachhangDetailError = function khachhangDetailError(error) {
  return {
    type: Constants.KHACHHANG_DETAIL_ERROR,
    error
  }
}

export const khachhangUpdateRequest = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const khachhangUpdateSuccess = function khachhangUpdateSuccess(response) {
  return {
    type: Constants.KHACHHANG_UPDATE_SUCCESS,
    payload: response
  }
}

export const khachhangUpdateError = function khachhangUpdateError(error) {
  return {
    type: Constants.KHACHHANG_UPDATE_ERROR,
    error
  }
}

export const cmbListRequest = function cmbListRequest(formData) {
  return {
    type: Constants.KHACHHANG_CMB_LIST_REQUESTING,
    payload: formData
  }
}

export const cmbListSuccess = function cmbListSuccess(data) {
  return {
    type: Constants.KHACHHANG_CMB_LIST_SUCCESS,
    data
  }
}

export const cmbListError = function cmbListError(error) {
  return {
    type: Constants.KHACHHANG_CMB_LIST_ERROR,
    error
  }
}

export const khachhangUserListRequest = function khachhangUserListRequest(formData) {
  return {
    type: Constants.KHACHHANG_USER_LIST_REQUESTING,
    payload: formData
  }
}

export const khachhangUserListSuccess = function khachhangUserListSuccess(data) {
  return {
    type: Constants.KHACHHANG_USER_LIST_SUCCESS,
    data
  }
}

export const khachhangUserListError = function khachhangUserListError(error) {
  return {
    type: Constants.KHACHHANG_USER_LIST_ERROR,
    error
  }
}

export const khachhangUserDetailRequest = function khachhangUserDetailRequest(formData) {
  return {
    type: Constants.KHACHHANG_USER_DETAIL_REQUESTING,
    payload: formData
  }
}

export const khachhangUserDetailSuccess = function khachhangUserDetailSuccess(data) {
  return {
    type: Constants.KHACHHANG_USER_DETAIL_SUCCESS,
    data
  }
}

export const khachhangUserDetailError = function khachhangDetailError(error) {
  return {
    type: Constants.KHACHHANG_USER_DETAIL_ERROR,
    error
  }
}

export const khachhangUserUpdateRequest = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_USER_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const khachhangUserUpdateSuccess = function khachhangUserUpdateSuccess(response) {
  return {
    type: Constants.KHACHHANG_USER_UPDATE_SUCCESS,
    payload: response
  }
}

export const khachhangUserUpdateError = function khachhangUserUpdateError(error) {
  return {
    type: Constants.KHACHHANG_USER_UPDATE_ERROR,
    error
  }
}

export const khachhangUploadRequest = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_UPLOAD_REQUESTING,
    payload: formData,
    callback
  }
}

export const khachhangUploadSuccess = function khachhangUploadSuccess(response) {
  return {
    type: Constants.KHACHHANG_UPLOAD_SUCCESS,
    payload: response
  }
}

export const khachhangUploadError = function khachhangUploadError(error) {
  return {
    type: Constants.KHACHHANG_UPLOAD_ERROR,
    error
  }
}

export const khachhangDvhcListRequest = function khachhangDvhcListRequest(formData) {
  return {
    type: Constants.KHACHHANG_DVHC_LIST_REQUESTING,
    payload: formData
  }
}

export const khachhangDvhcListSuccess = function khachhangDvhcListSuccess(data) {
  return {
    type: Constants.KHACHHANG_DVHC_LIST_SUCCESS,
    data
  }
}

export const khachhangDvhcListError = function khachhangDvhcListError(error) {
  return {
    type: Constants.KHACHHANG_DVHC_LIST_ERROR,
    error
  }
}

export const khachhangRemoveRequest = (formData, callback) => {
  return {
    type: Constants.KHACHHANG_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const khachhangRemoveSuccess = function khachhangRemoveSuccess(response) {
  return {
    type: Constants.KHACHHANG_REMOVE_SUCCESS,
    payload: response
  }
}

export const khachhangRemoveError = function khachhangRemoveError(error) {
  return {
    type: Constants.KHACHHANG_REMOVE_ERROR,
    error
  }
}

export const khachhangUpdateDiemTLRequest = (formData, onSuccess, onError) => {
  return {
    type: Constants.KHACHHANG_UPDATE_DIEM_TL_REQUESTING,
    formData,
    onSuccess,
    onError
  }
}

// update diem tich luy theo danh sach
export const khachhangUpdateListDiemTLRequest = (formData, onSuccess, onError) => {
  return {
    type: Constants.KHACHHANG_UPDATE_DIEM_TLS_REQUESTING,
    formData,
    onSuccess,
    onError
  }
}

export const khachhangSetError = (err) => {
  return {
    type: Constants.KHACHHANG_SET_ERROR,
    payload: err,
  }
}

export const khachhangSetMessage = (msg) => {
  return {
    type: Constants.KHACHHANG_SET_MESSAGE,
    payload: msg,
  }
}

export const khachhangSetRequesting = (flag) => {
  return {
    type: Constants.KHACHHANG_SET_REQUESTING,
    payload: flag,
  }
}

export const khachhangNhomListRequest = (formData) => {
  return {
    type: Constants.KHACHHANG_NHOM_LIST_REQUESTING,
    payload: formData
  }
}

export const khachhangNhomListSuccess = (data) => {
  return {
    type: Constants.KHACHHANG_NHOM_LIST_SUCCESS,
    data
  }
}

export const khachhangNhomListError = (error) => {
  return {
    type: Constants.KHACHHANG_NHOM_LIST_ERROR,
    error
  }
}

export const khachhangTraThuongRequest = (payload, callback) => {
  return {
    type: Constants.KHACHHANG_TRATHUONG_REQUESTING,
    payload,
    callback
  }
}

export const khachhangTraThuongSuccess = () => {
  return {
    type: Constants.KHACHHANG_TRATHUONG_SUCCESS,
  }
}

export const khachhangTraThuongError = (error) => {
  return {
    type: Constants.KHACHHANG_TRATHUONG_ERROR,
    error
  }
}

export const khachhangListDonRequest = (payload, callback) => {
  return {
    type: Constants.KHACHHANG_LIST_DON_247_REQUESTING,
    payload,
    callback
  }
}


// WEBPACK FOOTER //
// ./src/views/KhachHang/actions.js